<!-- <div class="page-title flex-grow-1">
<div class="mb-0">
  <div class="d-flex align-items-center">
    <div class="pl-2 pr-2">
      <a href="javascript:void(0)" (click)="goBack()" class="d-inline-flex">
        <img src="assets/images/grid-back.png"></a>
      </div>Token Screen
    </div>
  </div>
</div> -->

@if (activeSlideIndex != undefined) {
  <carousel [interval]="myInterval" [(activeSlide)]="activeSlideIndex"
    [showIndicators]="showIndicator" [isAnimated]="false" [noPause]="true" (activeSlideChange)="onSlideChange($event)">
    <!-- <div class="row"> -->
    @if (screen_data) {
      <div class="_token-card-container" [ngStyle]="{'background-color': screen_data?.bg_color_code ? screen_data?.bg_color_code : '#153b7f'}">
        @if (screen_data && !screen_data.title_image_id) {
          <img src="assets/images/token/token-bg.png" class="token-bg-img mb-2" alt="">
        }
        @if (screen_data && screen_data.title_image_id) {
          <img [src]="screen_data.bg_profile_path | secure  | async" (error)="$event.target.src='assets/images/token/token-bg.png'" loading="lazy" class="token-bg-img mb-2" alt="">
        }
        @for (d of doctorList; track d; let i = $index) {
          <div class="_wf-pp_divforcard wx_card _token"
            id="selecteddoc{{i}}">
            <div class="_token-card">
              <div class="_wf-pp-div-block-31 _wf-pp-leftcolumn">
                @if (!d.extra_data?.profile_id && d.extra_data?.gender_id == 'female') {
                  <img src="assets/images/doctor-female.png" loading="lazy" sizes="145px"
                    alt="">
                }
                @if (!d.extra_data?.profile_id && d.extra_data?.gender_id != 'female') {
                  <img src="assets/images/male-doctor.png" loading="lazy" sizes="145px"
                    alt="">
                }
                @if (d.extra_data?.profile_id) {
                  <img [src]="d.extra_data.profile_id | cachableSecure | async" loading="lazy" sizes="145px"
                    alt="">
                }
              </div>
              <div class="_wf-pp-div-block-32 _wf-pp-rightcolumn">
                <div class="_wf-pp-rightfirstdivfirst">
                  <div class="_wf-pp-text-block-14">
                    <strong class="_wf-pp-text-span-3 text-capitalize text-bold">{{d.desk_user_name}}</strong>
                  </div>
                  <!-- <div class="_wf-pp-text-block-14">
                  <span class="_wf-pp-text-span-3 text-capitalize" [ngClass]="d.stage == 'Serving'? 'online_Indicator' : 'offline_Indicator'"></span>
                </div> -->
              </div>
              <div class="_wf-pp-rightcolumnfirstdiv">
                <div class="_wf-pp-rightcolumnfirstdiv-content"> <!--main Div Display Flex -->
                  <div class="left-column"> <!-- left side-->
                    @if (d.speciality_name) {
                      <div class="_doc-card-subitems text-uppercase">
                        <!-- <i class="fa fa-stethoscope" aria-hidden="true"></i> -->
                        {{d.speciality_name}}
                      </div>
                    }
                    @if (d.room_name) {
                      <div class="_doc-card-subitems text-bold text-uppercase">
                        <!-- <i class="fa fa-medkit" aria-hidden="true"></i> -->
                        {{'field.label.room_number'| translate| async}}  {{d.room_name}}
                      </div>
                    }
                  </div>
                  <div class="right-column"> <!--Right Side Token No -->
                    @if (d.token) {
                      <div class="token">
                        <div class="token_number text-uppercase">{{"field.label.token_number"|translate|async}}</div>
                        <div class="text-bold token_number_view">{{d.token}}</div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  }
<!-- </div> -->
</carousel>
}
